export const updateListAdmin = list => ({
  type: 'UPDATE_LIST_ADMIN',
  payload: list,
});
